import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveProjectExpenseRequestFailure(projectExpense) {
      const state = getState().find(
        ({ projectExpense: { uuid } }) => projectExpense.uuid === uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isRemoveProjectExpenseRequestPending(projectExpense) {
      const state = getState().find(
        ({ projectExpense: { uuid } }) => uuid === projectExpense.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isRemoveProjectExpenseRequestSuccess(projectExpense) {
      const state = getState().find(
        ({ projectExpense: { uuid } }) => uuid === projectExpense.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
